import {PAdbContext} from "../PA.Core/PAdbContext";
import {ILease} from "../PA.Utils/PA.UtilsIF";
import {WB_Snapshot_TypeRow} from "../PA.Core/PAdbSchemaRows";
import * as AsyncLock from 'async-lock'
import * as _ from 'lodash';
import {GenericLease} from "../PA.Utils/GenericLease";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";
import {esWB_Company, esWB_Currency, esWB_Snapshot_Type} from "../PA.Core/PAdbSchema";

export class SnapshotTypeService {

    private static _dbContext: PAdbContext;
    private static _lease: ILease;

    private static dctSnapshotMByWbID: {[wbSnapshotTypeWbID: number]: WB_Snapshot_TypeRow} = {};
    private static dctSnapshotMBID: {[wbSnapshotTypeID: string]: WB_Snapshot_TypeRow} = {};

    private static dctLock: any = new AsyncLock();
    private static bIsLoaded: boolean = false;

    static async getSnapshotMByWbID(wbSnapshotMID: number) : Promise<WB_Snapshot_TypeRow> {
        return new Promise<WB_Snapshot_TypeRow>((resolve, error) => {
            SnapshotTypeService.dctLock.acquire('global',
                (done: any) => {
                    SnapshotTypeService.checkLease()
                        .then((ignore) => {
                            if (wbSnapshotMID in SnapshotTypeService.dctSnapshotMByWbID) {
                                done(null, SnapshotTypeService.dctSnapshotMByWbID[wbSnapshotMID]);
                                resolve(SnapshotTypeService.dctSnapshotMByWbID[wbSnapshotMID]);
                                return;
                            } else if (!(wbSnapshotMID in SnapshotTypeService.dctSnapshotMByWbID) && SnapshotTypeService.bIsLoaded) {
                                done(null, SnapshotTypeService.dctSnapshotMByWbID[wbSnapshotMID]);
                                resolve(undefined);
                                return;
                            }

                            return SnapshotTypeService.loadFromDB()
                        })
                        .then((ignore) => {
                            done(null, SnapshotTypeService.dctSnapshotMByWbID[wbSnapshotMID]);
                            resolve(SnapshotTypeService.dctSnapshotMByWbID[wbSnapshotMID]);
                            return;
                        })
                        .catch((err) => {
                            error(err);
                        });
                })
        })
    }

    static async getSnapshotMByID(snapshotMID: string) : Promise<WB_Snapshot_TypeRow> {
        return new Promise<WB_Snapshot_TypeRow>((resolve, error) => {
            SnapshotTypeService.dctLock.acquire('global',
                (done: any) => {
                    SnapshotTypeService.checkLease()
                        .then((ignore) => {
                            if (snapshotMID in SnapshotTypeService.dctSnapshotMBID) {
                                done(null, SnapshotTypeService.dctSnapshotMBID[snapshotMID]);
                                resolve(SnapshotTypeService.dctSnapshotMBID[snapshotMID]);
                                return;
                            } else if (!(snapshotMID in SnapshotTypeService.dctSnapshotMBID) && SnapshotTypeService.bIsLoaded) {
                                done(null, SnapshotTypeService.dctSnapshotMBID[snapshotMID]);
                                resolve(undefined);
                                return;
                            }

                            return SnapshotTypeService.loadFromDB()
                        })
                        .then((ignore) => {
                            done(null, SnapshotTypeService.dctSnapshotMBID[snapshotMID]);
                            resolve(SnapshotTypeService.dctSnapshotMBID[snapshotMID]);
                            return;
                        })
                        .catch((err) => {
                            error(err);
                        });
                })
        })
    }

    static async reset() : Promise<void> {
        SnapshotTypeService.instantiateContext();
        let arr: any[] = _.values(SnapshotTypeService.dctSnapshotMByWbID);
        await SnapshotTypeService._dbContext.purgeCache(esWB_Snapshot_Type, arr);
        SnapshotTypeService.dctSnapshotMByWbID = {};
        SnapshotTypeService.dctSnapshotMBID = {};
        SnapshotTypeService.bIsLoaded = false;
    }

    private static async loadFromDB() : Promise<void> {
        SnapshotTypeService.bIsLoaded = false;

        SnapshotTypeService.instantiateContext();

        let snapshotMs: WB_Snapshot_TypeRow[] = await SnapshotTypeService._dbContext.findAll(esWB_Snapshot_Type, {where: {DELETED_IND: {neq: '1'}}}, {with:[esWB_Company, esWB_Currency]});
        _.forEach(snapshotMs, (aSnapshotM) => {
            SnapshotTypeService.dctSnapshotMByWbID[aSnapshotM.cif.WB_SNAPSHOTM_ID] = aSnapshotM;
            SnapshotTypeService.dctSnapshotMBID[aSnapshotM.cif.SNAPSHOT_TYPE_ID] = aSnapshotM;
        });

        SnapshotTypeService.bIsLoaded = true;
        SnapshotTypeService._lease.resetLease();
    }

    private static instantiateContext() {
        if (_.isUndefined(SnapshotTypeService._dbContext)){
            SnapshotTypeService._dbContext = new PAdbContext();
        }
    }

    private static async checkLease() : Promise<void> {
        if (_.isUndefined(SnapshotTypeService._lease)) {
            SnapshotTypeService._lease = new GenericLease(LeaseRegistry.Lease_Type_SnapshotM);
        }

        if (await SnapshotTypeService._lease.hasDataChanged()) {
            await SnapshotTypeService.reset();
        }
    }
}